import { colorStrings, mediaQueriesBP } from "@iewc/Utilities/variables";
import { cartLinkStyles as styles } from "@insite/content-library/Widgets/Common/CartLink";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.routerLink = {
    ...styles.routerLink,
    mergeCss: true,

    typographyProps: {
        css: css`
            &&&& span {
                &[data-test-selector="cartLinkQuantityContainer"] {
                    color: transparent;

                    &:hover {
                        color: transparent;
                    }
                }

                &[data-test-selector="cartLinkQuantity"] {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                    font-size: 12px;
                }
            }
        `,
    },
    css: css`
        ${styles.routerLink?.css}
        position: relative;

        ${IconWrapper} {
            margin: 0;
        }

        ${({ theme }) => {
            const {
                header: { backgroundColor },
            } = theme;
            return css`
                &.cartLink-compact:hover {
                    &&&& span {
                        text-decoration: none;
                        color: ${getColor(backgroundColor)};
                    }
                }

                &:hover {
                    &&&& span {
                        text-decoration: none;

                        &[data-test-selector="cartLinkQuantityContainer"] {
                            color: transparent;
                        }
                    }
                }
            `;
        }}

        svg {
            color: ${getColor(colorStrings.textMain)};
        }
    `,
};

styles.desktopCountText = {
    ...styles.desktopCountText,
    color: colorStrings.commonGlobalWhite,
    css: css`
        border-radius: 50%;
        min-width: 20px;
        display: flex;
        height: 20px;
        margin: 0;
        position: absolute;
        top: 2px;
        right: 0;
        text-align: center;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 600;
        color: ${getColor(colorStrings.commonGlobalWhite)} !important;
        background-color: ${getColor(colorStrings.primaryMain)};
        &:hover {
            text-decoration: none;
            color: ${getColor(colorStrings.commonGlobalWhite)} !important;
        }
    `,
};

styles.mobileCountText = {
    ...styles.mobileCountText,
    css: css`
        display: none;
        ${mediaQueriesBP.maxLG} {
            border-radius: 50%;
            min-width: 20px;
            display: flex;
            height: 20px;
            margin: 0;
            position: absolute;
            top: 2px;
            left: 80%;
            text-align: center;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            font-weight: 600;
            color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            background-color: ${getColor(colorStrings.primaryMain)};
            &:hover {
                text-decoration: none;
                color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            }
        }
    `,
};

styles.compactCountText = {
    ...styles.compactCountText,
    css: css`
        ${({ theme }) => {
            const {
                header: { backgroundColor, linkColor },
            } = theme;
            return css`
                border-radius: 50%;
                width: 20px;
                display: flex;
                height: 20px;
                margin: 0 0 20px -6px;
                text-align: center;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                font-weight: 600;
                color: ${getColor(colorStrings.commonGlobalWhite)};
                background-color: ${getColor(colorStrings.primaryMain)};

                &:hover {
                    text-decoration: none;
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            `;
        }}
    `,
};
